const Chart = require("chart.js");

// Chart extension for making the bars rounded
// Code from: https://codepen.io/jedtrow/full/ygRYgo

const mode = "light"; //(themeMode) ? themeMode : 'light';
const fonts = {
    base: "Open Sans",
};

// Colors
const colors = {
    gray: {
        100: "#f6f9fc",
        200: "#e9ecef",
        300: "#dee2e6",
        400: "#ced4da",
        500: "#adb5bd",
        600: "#8898aa",
        700: "#525f7f",
        800: "#32325d",
        900: "#212529",
    },
    theme: {
        default: "#B7CAD8",
        primary: "#5e72e4",
        secondary: "#f4f5f7",
        info: "#11cdef",
        success: "#2dce89",
        danger: "#f5365c",
        warning: "#fb6340",
    },
    black: "#12263F",
    white: "#FFFFFF",
    transparent: "transparent",
    yangarooBlue:"#00ADEF"
};

// Methods

// Chart.js global options
function chartOptions() {
    // Options
    var options = {
        defaults: {
            responsive: true,
            maintainAspectRatio: false,
            defaultColor: mode === "dark" ? colors.gray[700] : colors.gray[600],
            defaultFontColor: mode === "dark" ? colors.gray[700] : colors.gray[600],
            defaultFontFamily: fonts.base,
            defaultFontSize: 13,
            layout: {
                padding: 0,
            },
            plugins: {
                legend: {
                    display: false,
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        padding: 16,
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: "index",
                    intersect: false,
                },
            },
            elements: {
                point: {
                    radius: 0,
                    backgroundColor: colors["yangarooBlue"],
                },
                line: {
                    tension: 0.4,
                    borderWidth: 4,
                    borderColor: colors["yangarooBlue"],
                    backgroundColor: colors.transparent,
                    borderCapStyle: "rounded",
                },
                bar: {
                    backgroundColor: colors.theme["warning"],
                },
                arc: {
                    backgroundColor: colors["yangarooBlue"],
                    borderColor: mode === "dark" ? colors.gray[800] : colors.white,
                    borderWidth: 4,
                },
            },
        },
        overrides: {
            doughnut: {
                cutoutPercentage: 83,
                legendCallback: function (chart) {
                    var data = chart.data;
                    var content = "";

                    data.labels.forEach(function (label, index) {
                        var bgColor = data.datasets[0].backgroundColor[index];

                        content += '<span class="chart-legend-item">';
                        content +=
                            '<i class="chart-legend-indicator" style="background-color: ' +
                            bgColor +
                            '"></i>';
                        content += label;
                        content += "</span>";
                    });

                    return content;
                },
            },
        }
    };


    // yAxes
    Chart.defaults.scales["linear"] = {
        grid: {
            borderDash: [2],
            borderDashOffset: [2],
            color: mode === "dark" ? colors.gray[900] : colors.gray[100],
            drawBorder: false,
            drawTicks: false,
            lineWidth: 0,
            zeroLineWidth: 0,
            zeroLineColor: mode === "dark" ? colors.gray[900] : colors.gray[100],
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
        },
        ticks: {
            beginAtZero: true,
            padding: 10,
            callback: function (value) {
                if (!(value % 10)) {
                    return value;
                }
            },
        },
    };

    // xAxes
    Chart.defaults.scales["category"]= {
        grid: {
            drawBorder: false,
            drawOnChartArea: false,
            drawTicks: false,
        },
        ticks: {
            ...Chart.defaults.scales["category"].ticks,
            padding: 20,
        },
    };
    return options;
}

// Parse global options
function parseOptions(parent, options) {
    for (var item in options) {
        if (typeof options[item] !== "object") {
            parent[item] = options[item];
        } else {
            parseOptions(parent[item], options[item]);
        }
    }
}

export {
    chartOptions,
    parseOptions,
    colors
};